import {Anfrage} from "@/model/Anfrage";
import storeUtils from "@/businesslogic/utils/storeUtils";

export default function anredeUtils(): any {
    const {
        istProdukt,
        istFhkVerkaufsprodukt,
        enthaeltVHV,
        gebaeudetypIstWeg,
        miteigentuemerTypIstWeg,
        miteigentuemerTypIstEtg,
        miteigentuemerTypIstEhe,
        istAlleineigentuemer,
        isUnbebautesGrundstueck } = storeUtils()

    const miteigentuemerIstWeg = (storeData: Anfrage): boolean => {
        return istProdukt(storeData, ["bh", "bl"]) &&
            miteigentuemerTypIstWeg(storeData);
    };

    const miteigentuemerIstEtg = (storeData: Anfrage): boolean => {
        return istProdukt(storeData, ["hg", "bh", "bl"]) &&
            miteigentuemerTypIstEtg(storeData);
    };

    const miteigentuemerIstEhe = (storeData: Anfrage): boolean => {
        return istProdukt(storeData, ["hg", "bl", "bh"]) &&
            miteigentuemerTypIstEhe(storeData);
    };

    const alleineigentuemer = (storeData: Anfrage): boolean => {
        return istProdukt(storeData, ["bl", "bh"]) &&
            istAlleineigentuemer(storeData);
    };

    const istFerienhausVhvEnthalten = (storeData: Anfrage): boolean => {
        return istFhkVerkaufsprodukt(storeData) &&
            enthaeltVHV(storeData);
    };

    const unbebautesGrundstueck = (storeData: Anfrage): boolean => {
        return istProdukt(storeData, ["hg"]) &&
            isUnbebautesGrundstueck(storeData);
    };

    const istEtgOderWeg = (storeData: Anfrage): boolean => {
        return gebaeudetypIstWeg(storeData) ||
            miteigentuemerIstWeg(storeData) ||
            miteigentuemerIstEtg(storeData);
    }

    const wegAnredeErlaubt = (storeData: Anfrage, istVerwalter: boolean): boolean => {
        return istProdukt(storeData, ["vgv", "bl", "bh", "hg", "fh2024"]) &&
            !miteigentuemerIstEtg(storeData) &&
            !miteigentuemerIstEhe(storeData) &&
            !alleineigentuemer(storeData) &&
            !istFerienhausVhvEnthalten(storeData) &&
            !unbebautesGrundstueck(storeData) &&
            !istVerwalter;
    }

    const etgAnredeErlaubt = (storeData: Anfrage, istVerwalter: boolean): boolean => {
        return istProdukt(storeData, ["vgv", "bl", "bh", "hg", "fh2024"]) &&
            !gebaeudetypIstWeg(storeData) &&
            !miteigentuemerIstEhe(storeData) &&
            !miteigentuemerIstWeg(storeData) &&
            !alleineigentuemer(storeData) &&
            !istFerienhausVhvEnthalten(storeData) &&
            !istVerwalter
    }

    const firmaAnredeErlaubt = (storeData: Anfrage, istVerwalter: boolean): boolean => {
        return (istProdukt(storeData, ["vgv", "bl", "bh", "hg", "fh2024"]) && !istFerienhausVhvEnthalten(storeData) && !istEtgOderWeg(storeData)) || istVerwalter;
    }

    const personAnredeErlaubt =(storeData: Anfrage, istVerwalter: boolean): boolean => {
        return !istEtgOderWeg(storeData) || istVerwalter;
    };

    const anredeIstOrganisation = (anrede: string): boolean => {
        return anredeIstFirma(anrede) || anredeIstEtgOderWeg(anrede);
    }

    const anredeIstEtgOderWeg = (anrede: string): boolean => {
        return anredeIstWeg(anrede) || anredeIstEtg(anrede);
    }

    const anredeIstFirma = (anrede: string): boolean => {
        return anrede === "0003";
    }

    const anredeIstWeg = (anrede: string): boolean => {
        return anrede === "WEG";
    }

    const anredeIstEtg = (anrede: string): boolean => {
        return anrede === "ETG";
    }

    return {
        wegAnredeErlaubt,
        etgAnredeErlaubt,
        firmaAnredeErlaubt,
        personAnredeErlaubt,
        anredeIstOrganisation,
        anredeIstEtgOderWeg,
        anredeIstFirma,
        anredeIstWeg
    }
}